import React, { useState } from "react";
import { ListAlt } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { useCanViewBom } from "fond/hooks/useCanViewBom";
import InteractiveBomModal from "fond/project/bom/InteractiveBom/InteractiveBomModal";
import { Project } from "fond/types";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  project: Project;
  handleClose: () => void;
}

const InteractiveBom: React.FC<IProps> = ({ project, handleClose }: IProps) => {
  const [modalOpen, showModal] = useState(false);
  const canViewBom = useCanViewBom(project);
  const handleClick = () => {
    if (canViewBom) {
      showModal(true);
      handleClose();
      trackPageMenuItemClick("project", "interactive_bom", project);
    }
  };

  return (
    <>
      <MenuItem onClick={handleClick} disabled={!canViewBom}>
        <ListItemIcon>
          <ListAlt />
        </ListItemIcon>
        Interactive Bill of Materials
      </MenuItem>
      {modalOpen && <InteractiveBomModal project={project} onClose={() => showModal(false)} />}
    </>
  );
};

export default InteractiveBom;
